
import React, { Component } from "react";
// import "./LandingPage.css";


const LandingPage = ({ history }) => {
  return (
    <div>
IMS Version 2
    </div>
  );
};

LandingPage.propTypes = {};

export default LandingPage;
